export default __webpack_public_path__ + "static/media/miguel-lopes-2.cc7fe2d5.jpg";